import AsyncStorage from '@react-native-async-storage/async-storage';

export type CatalogCreateFormLayout = 'express' | 'full';

const storageKey = (organizationId: string) => `catalogCreateFormLayout:${organizationId}`;

export async function readCatalogCreateFormLayout(
  organizationId: string,
): Promise<CatalogCreateFormLayout> {
  const raw = await AsyncStorage.getItem(storageKey(organizationId));
  return raw === 'full' ? 'full' : 'express';
}

export async function writeCatalogCreateFormLayout(
  organizationId: string,
  layout: CatalogCreateFormLayout,
): Promise<void> {
  await AsyncStorage.setItem(storageKey(organizationId), layout);
}
